import { useLang } from "@/lib/i18n";
import { useSiteContent } from "@/lib/firestoreService";

export const WhyChooseUs = () => {
  const { t, lang } = useLang();
  const site = useSiteContent();
  const h1 = lang === "en" ? site.why_h1 : t.why.h1;
  const h2 = lang === "en" ? site.why_h2 : t.why.h2;
  return (
    <section data-testid="why-choose-us-section" className="relative py-8 sm:py-10 bg-[#EFD9B4]/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <div className="brand-ribbon mb-2">{t.why.ribbon}</div>
          <h2 className="font-display text-xl sm:text-2xl lg:text-3xl font-bold text-[#5A2D1D]">
            {h1} <span className="italic text-[#7A3B25]">{h2}</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.reasons.map((r, i) => (
            <div
              key={r.title}
              data-testid={`reason-${i}`}
              className="bg-[#F5E6CC] border border-[#5A2D1D]/25 rounded-sm p-7 hover-lift"
            >
              <h3 className="font-display text-xl font-bold text-[#5A2D1D]">{r.title}</h3>
              <p className="mt-2 text-sm text-[#2E1A12]/80 leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
